module.exports = __webpack_public_path__ + "static/img/prize_act.34c78cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/prize_act.png
// module id = 4ycP
// module chunks = 1